module.exports = __webpack_public_path__ + "static/bg-box1-85800095360037cbd521a369246067f3.png";